export const HOME_LIST_MAX_HEIGHT = "calc(100vh - 330px)"
